import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./healthBenefitsTab.css";

const HealthBenefitsSection = ({ productsdetailss }) => {
  const benefits = [
    {
      id: 1,
      title: "Boosts Energy & Stamina",
      description:
        "Rich in natural nutrients that help improve energy levels and reduce daily fatigue.",
    },
    {
      id: 2,
      title: "Strengthens Immunity",
      description:
        "Packed with antioxidants and vitamins that support the body's natural defense system.",
    },
    {
      id: 3,
      title: "Supports Daily Nutrition",
      description:
        "Provides essential proteins, minerals, and nutrients needed for balanced daily nutrition.",
    },
    {
      id: 4,
      title: "Aids Digestion & Detox",
      description:
        "Helps support healthy digestion and assists the body's natural detox process.",
    },
    {
      id: 5,
      title: "Promotes Overall Well-Being",
      description:
        "Contributes to better wellness, vitality, and long-term health when used regularly.",
    },
  ];

  return (
    <div className="health-section">
      <Container>
        <Row>
          {productsdetailss?.map((item, index) => (
            <Col key={item.id} lg={6} md={6} sm={12} className="mb-4">
              <div className="benefit-card">
                <h5>
                  {index + 1}. {item?.health_benefit}
                </h5>
                <p>{item?.health_description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default HealthBenefitsSection;
